import {trans} from '@frontend/helpers'
import {ButtonsSwitch} from 'swayok-react-mdb-ui-kit/components/Button/ButtonsSwitch'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {FilterLabel} from './FilterLabel'

export type CommunicationMethod = 'phone' | 'messages'

export type CommunicationMethodFilterValue = CommunicationMethod[]

interface Props {
    value: CommunicationMethodFilterValue
    onChange: (value: CommunicationMethodFilterValue) => void
    disabled?: boolean
    noLabel?: boolean
}

// Фильтр по способу связи с продавцом.
export function CommunicationMethodFilter(props: Props) {

    const {
        value,
        onChange,
        disabled,
        noLabel,
    } = props

    const labels = trans().ads.list.filters.communication_methods

    const onToggle = useEventCallback((method: CommunicationMethod) => {
        onChange(
            value.includes(method)
                ? value.filter(item => item !== method)
                : [...value, method]
        )
    })

    return (
        <div className="ad-communication-method-filter pb-4">
            {!noLabel && (
                <FilterLabel
                    label={trans().ads.list.filters.communication_method}
                    disabled={disabled}
                />
            )}
            <ButtonsSwitch<CommunicationMethod>
                options={[
                    {
                        label: labels.phone,
                        value: 'phone',
                    },
                    {
                        label: labels.messages,
                        value: 'messages',
                    },
                ]}
                value={value}
                className="full-width"
                buttonsProps={{
                    className: 'flex-1',
                }}
                disabled={disabled}
                onChange={onToggle}
            />
        </div>
    )
}
